import './header.scss';

import React, { useState } from 'react';

import {Navbar, Nav, NavbarToggler, Collapse, Alert} from 'reactstrap';
import LoadingBar from 'react-redux-loading-bar';

import {Home, Brand, ThemeSwitcher, RoleSwitcher} from './header-components';
import { AdminMenu, EntitiesMenu, AccountMenu } from '../menus';
import account from "app/shared/layout/menus/account";

export interface IHeaderProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isOpenAPIEnabled: boolean;
  account:  any;
}

const Header = (props: IHeaderProps) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const renderDevRibbon = () =>
    props.isInProduction === false ? (
      <div className="ribbon dev">
        <a href="">Development</a>
      </div>
    ) : null;

  const toggleMenu = () => setMenuOpen(!menuOpen);

  /* jhipster-needle-add-element-to-menu - JHipster will add new menu items here */

  return (
    <div id="app-header">
      {renderDevRibbon()}
      <LoadingBar className="loading-bar" />
      <Navbar data-cy="navbar" dark expand="sm" fixed="top" className="jh-navbar">
        <NavbarToggler aria-label="Menu" onClick={toggleMenu} />
        <Brand />
        <Collapse isOpen={menuOpen} navbar>
          {props.account && props.account.login ? (
            <span>You are logged in as user {props.account.login}.</span>
          ):( <div> </div>)
          }
          <Nav id="header-tabs" className="ml-auto" navbar>
            <RoleSwitcher />
            <ThemeSwitcher />
            <Home />
            {props.isAuthenticated && <EntitiesMenu />}
            {props.isAuthenticated  && <AdminMenu showOpenAPI={props.isOpenAPIEnabled} />}
            <AccountMenu isAuthenticated={props.isAuthenticated} />
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default Header;
